/*
---
description: FED Process
authors:
- David Chan CK
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [BasicMaps]
...
*/
var HoodsMap = new Class({
	Implements: [Options, Events],

	options: {
		api: ('https:' == document.location.protocol ? 'https://' : 'http://') + 'maps.google.com/maps/api/js?' +
			'key=' + window['GOOGLE_API_key'] + '&' +
			'libraries=visualization',
		data: '',
		map_styles:	[
			{
				"featureType": "road.arterial",
				"stylers": [
					{ "color": "#e4e4e4" }
				]
			},{
				"featureType": "road.arterial",
				"elementType": "geometry.stroke",
				"stylers": [
					{ "color": "#808080" }
				]
			},{
				"featureType": "landscape",
				"stylers": [
					{ "color": "#f6f3f0" }
				]
			},{
				"featureType": "water",
				"stylers": [
					{ "color": "#b3c2d0" }
				]
			},{
				"featureType": "road.highway",
				"stylers": [
					{ "color": "#b4b4b4" }
				]
			},{
				"featureType": "poi",
				"stylers": [
					{ "color": "#cddbc9" }
				]
			},{
				"featureType": "road.arterial",
				"elementType": "labels.text.fill",
				"stylers": [
					{ "color": "#000000" }
				]
			},{
				"featureType": "poi",
				"elementType": "labels.text.fill",
				"stylers": [
					{ "color": "#000000" }
				]
			},{
				"featureType": "poi.government",
				"elementType": "labels.text.fill",
				"stylers": [
					{ "color": "#000000" }
				]
			},{
				"featureType": "landscape",
				"elementType": "labels.text.fill",
				"stylers": [
					{ "color": "#000000" }
				]
			},{
				"featureType": "road",
				"elementType": "geometry.stroke",
				"stylers": [
					{ "color": "#a5a5a5" }
				]
			},{
				"featureType": "landscape",
				"elementType": "geometry.stroke",
				"stylers": [
					{ "color": "#dadbda" }
				]
			},{
				"featureType": "transit",
				"elementType": "labels.icon",
				"stylers": [
					{ "saturation": 100 }
				]
			},{
				"featureType": "poi.park"
			},{
				"featureType": "poi",
				"elementType": "labels",
				"stylers": [
					{ "visibility": "off" }
				]
			}
		]
	},

	initialize: function(_element, options){
		if (_element){
			this.setOptions(options);
			this._element = _element;
			this.fireEvent('initialize', this)
					.build();
		}
	},

	build: function(){
		var opts = this.options;
		var self = this;

		if(!GoogleApiLoad){
			this.u_cb_id = 'map_onload_callback_'+((((1+Math.random())*0x10000)|0).toString(16));

			window[this.u_cb_id] = function(){
				self.get_data();
			}.bind(this);

			new Asset.javascript(opts.api+'&callback='+this.u_cb_id+'&other_params=client',
			{
				'onload': function(){ GoogleApiLoad = true; }
			});
		}else{
			self.get_data();
		}
	},

	get_data: function(){
		var self = this;

		if(self.options.data != ''){
			self.data = self.options.data;
			self.draw_map();
		}else if(self._element.getAttribute('data-rpc')){
			var url = self._element.getAttribute('data-rpc');

			new Remote({
				rpc: url,
				onSuccess: function(){ self.data = this.get_data(); self.draw_map(); },
				onError: function(){ self._element.hide(); }
			});
		}else{
			return;
		}
	},

	draw_map: function() {
		var data = this.data;

		if(data.data.length > 0){
			var lat = data.center.lat || 40.7646;
			var lng = data.center.lng || -73.9777;
			var zoom = data.zoom || 13;

			var center = new google.maps.LatLng(lat, lng);

			this.map = new google.maps.Map(this._element, {
				center: center,
				zoom: zoom,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				fullscreenControl: false
			});

			this.map.setOptions({styles: this.options.map_styles});

			(function(){ this.fireEvent('ready'); }.bind(this)).delay(2000);
		}else{
			this.fireEvent('noData');
		}
	}
});
